/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Payor/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Payor({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Payor",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#3B95E7"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Payor.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-Z2iNoAa': alignSelf,'--mt-2-Z2iNoAa': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2iNoAa': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2iNoAa': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2iNoAa': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2iNoAa': opacity,'--w-10-Z2iNoAa': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2iNoAa': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2iNoAa': fill,'--a-7-Z2iNoAa': isAnimated ? animation : "none",'--sd-8-Z2iNoAa': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2iNoAa': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Payor.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M18 10a8 8 0 10-14.678 4.408A8 8 0 0018 10zm-8 6.286c.629 0 1.235-.092 1.808-.264-.495-2.244-2.01-4.093-4.585-4.093-1.08 0-2.013.372-2.795.983A6.285 6.285 0 0010 16.286zm2.964-.741a6.312 6.312 0 002.672-2.758 4.278 4.278 0 00-4.189-.183c.054.06.107.12.159.183.666.798 1.108 1.757 1.358 2.758zm-5.56-9.838a2.566 2.566 0 110 5.132 2.566 2.566 0 010-5.132zm8.08 3.31a2.126 2.126 0 10-4.252 0 2.126 2.126 0 004.251 0z"
 style={{'--f-12-Z2iNoAa': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}